import { Card, Collapse, FormInstance, Input, Row } from 'antd';
import React from 'react';
import { CaretRightOutlined } from '@ant-design/icons';
import FormInput from 'components/FormInput';
import Title from 'components/Title';
import AdressesList from './AdressesList';
import Address from 'components/address';
import GetLabel from 'DisplayFramework/components/GetLabel';
import AddressSFS from 'components/theme_components/ThirdParty/address/AddresseSFS';
const { Panel } = Collapse;

export type AddressProps = {
  form: FormInstance;
  id: number;
  showAsModal?: boolean;
};

const AddressCard = (props: AddressProps) => {
  const form = props.form;

  return (
    <>
      <Card
        title={<GetLabel label="primary-address" style={{ fontWeight: 'bold', paddingLeft: 15 }} />}
        style={{
          width: '100%',
          boxShadow:
            'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
          marginBottom: 10,
        }}
        bordered
      >
        <Row gutter={16}>
          <FormInput col xs={10} name="tpmainadrstreet1" comcode='tpmainadrstreet1'>
            <Input disabled={!!props.id && form.getFieldValue('tptype') === "CONC"} />
          </FormInput>

          <FormInput col xs={10} name="tpmainadrstreet2" comcode='tpmainadrstreet2'>
            <Input disabled={!!props.id && form.getFieldValue('tptype') === "CONC"} />
          </FormInput>
        </Row>
        <Row gutter={16}>
          <AddressSFS
            form={form}
            paysField="tpmainadrcountry"
            regionField="tpmainadrregion"
            regionGlobalField='tpmainadrregionglobale'
            villeField="tpmainadrcity"
            codePostalField="tpmainadrzipcode"
            addValue={!props.id && localStorage?.getItem('userrole') === 'ADMIN'}
            disabled={!!props.id && form.getFieldValue('tptype') === "CONC"}
            style={{ marginTop: '30px' }}
          />

          {/* <FormInput col xs={6} name="tpmainadrcountry">
              <ParListSelect
                disabled={!!props.id}
                parcode="TPIDENTCNT"
                onChange={() =>
                  form.setFieldsValue({
                    tpmainadrregion: '',
                    tpmainadrcity: '',
                    tpmainadrzipcode: '',
                  })
                }
              />
            </FormInput>

            <FormInput col xs={6} name="tpmainadrregion">
              <ParListSelect
                disabled={!!props.id}
                parcode="TPREGION"
                parvalueparent={form.getFieldValue('tpmainadrcountry')}
                onChange={() =>
                  form.setFieldsValue({
                    tpmainadrcity: '',
                    tpmainadrzipcode: '',
                  })
                }
              />
            </FormInput>
            <FormInput col xs={6} name="tpmainadrcity">
              <ParListSelect
                disabled={!!props.id}
                parcode="CITY"
                parvalueparent={form.getFieldValue('tpmainadrregion')}
                onChange={() => form.setFieldsValue({ tpmainadrzipcode: '' })}
              />
            </FormInput>
            <FormInput col xs={2} name="tpmainadrzipcode">
              <ParListSelect
                disabled={!!props.id}
                parcode="ZIPCODE"
                parvalueparent={form.getFieldValue('tpmainadrcity')}
              />
            </FormInput> */}
        </Row>
      </Card>

      <Collapse
        bordered={false}
        defaultActiveKey={['1']}
        expandIcon={({ isActive }) => (
          <CaretRightOutlined
            style={{ fontSize: 24, float: 'left' }}
            rotate={isActive ? 90 : 0}
          />
        )}
        expandIconPosition="left"
      >
        <Panel
          disabled={!props.id}
          header={<Title level={5} comcode="all-addresses"></Title>}
          key="2"
          style={{
            marginBottom: 24,
            overflow: 'hidden',
            background: '#f7f7f7',
            boxShadow:
              'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
            border: 10,
            borderRadius: 2,
          }}
        >
          <Card bordered>
            <AdressesList
              form={form}
              tpid={props.id}
              showAsModal={props.showAsModal}
            />
          </Card>
        </Panel>
      </Collapse>
    </>
  );
};
export default AddressCard;
